module.exports = __webpack_public_path__ + "static/media/home3_bg.cc77ab05.png";